export const AUTH_URL = 'https://auth.pellin.eu';
export const SERVER_MCP_TODO_URL = 'http://192.168.1.100:3210';
